import { setUserId, trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import {
  createCsAgentFeatureUsed_1_0_0 as createCsAgentFeatureUsedEvent,
  createUser_1_0_0 as createUserContext,
} from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup';

import { TRACKER_NAME, initialiseSnowplowTracker } from './initialiseTracker';

type Agent = {
  id: string;
  email: string;
};

/**
 * Report that a CS agent used a tracked feature, for the Agent Actions dashboard.
 *
 * The featureId needs a matching entry in `CsDashboard/features/registry.ts` to
 * render, and the dashboard's team-leader filter matches on the agent's email.
 *
 * Never throws: callers fire this after the agent's action already succeeded.
 */
export function trackCsAgentFeatureUsed(featureId: string, agent: Agent): void {
  try {
    if (!initialiseSnowplowTracker()) {
      return;
    }

    setUserId(agent.id, [TRACKER_NAME]);

    trackSelfDescribingEvent(
      {
        event: createCsAgentFeatureUsedEvent({ featureId }),
        context: [
          createUserContext({
            id: agent.id,
            email: agent.email,
            first_name: null,
            is_spoofed: null,
          }),
        ],
      },
      [TRACKER_NAME],
    );
  } catch (error) {
    console.error('[trackCsAgentFeatureUsed] Failed to track event', { featureId, error });
  }
}
